import { Box } from "@twilio-paste/core/box";
import { Table, TBody, Td, Th, THead, Tr } from "@twilio-paste/core/table";
import { graphql, Link, useStaticQuery } from "gatsby";
import { EntityComponent, SitesQuery } from "queries";
import React from "react";
import { Element } from "react-scroll";
import { getLastValidElementFromPath } from "../../helper";
import { AnchoredHeading } from "../../shared/components";
import { SITE_SCROLL_MARGIN } from "../../shared/constants";
import { codify } from "../../utils/stringUtils";

const headers = ["Key", "Component", "Condition", "Align", "Description"];
const query = graphql`
    {
        pages: allSitePage {
            nodes {
                ...SitePath
            }
        }
    }
`;

function ComponentChildren(props: { component: EntityComponent }) {
    const {
        component: { children }
    } = props;

    const { pages }: SitesQuery = useStaticQuery(query);

    if (!props.component.children?.length) {
        return null;
    }

    return (
        <Element id="component-children" name="component-children" style={{ scrollMarginTop: SITE_SCROLL_MARGIN }}>
            <Box paddingBottom="space200" as="section">
                <AnchoredHeading as="h3" variant="heading30">
                    Component children
                </AnchoredHeading>
                <Box overflow="auto">
                    <Box minWidth={["size80", undefined, undefined]}>
                        <Table>
                            <THead>
                                <Tr>
                                    {headers.map((header) => (
                                        <Th key={header}>{header}</Th>
                                    ))}
                                </Tr>
                            </THead>
                            <TBody>
                                {children.map((child) => {
                                    let componentName: string | React.ReactElement = child.type;
                                    const pathForComponent = pages.nodes.filter(
                                        ({ path }: { path: string }) => getLastValidElementFromPath(path) === child.type
                                    );
                                    if (pathForComponent.length) {
                                        componentName = <Link to={pathForComponent[0].path}>{child.type}</Link>;
                                    }

                                    return (
                                        <Tr key={child.key}>
                                            <Td>{child.key}</Td>
                                            <Td>{componentName}</Td>
                                            <Td>
                                                <div dangerouslySetInnerHTML={{ __html: codify(child.condition) }} />
                                            </Td>
                                            <Td>{child.align}</Td>
                                            <Td>
                                                <div dangerouslySetInnerHTML={{ __html: codify(child.description) }} />
                                            </Td>
                                        </Tr>
                                    );
                                })}
                            </TBody>
                        </Table>
                    </Box>
                </Box>
            </Box>
        </Element>
    );
}

export { ComponentChildren };
